import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customerHistory',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      settingFor: 'customer',
      isDetLoading: true,
      customerAllData: null,
      menuVisible: true,
      customerName: '',
      lang: '',

      property: null,
      dmCases: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "caseId",
        isLoading: true,
      },
      dmAgreements: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "reference",
        isLoading: true,
      },
      dmInvestigations: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "id",
        isLoading: true,
      },    
      deposits: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "custkey",
        isLoading: true,
      },  
      selectedAgreemNo: 0,

      propId: null,
      custkey: null,

      pagesLoaded: ['Deposits', 'DmInvestigations', 'DmAgreements', 'DmCases'],
    }
  },
  mounted() {
    this.goToDefaultTab(this.selectedTab);
  },
  computed: {   
    isLoading: function () {
      return this.dmCases.isLoading && this.dmAgreements.isLoading && this.dmInvestigations.isLoading && this.deposits.isLoading;
    },
    showEmptyState: function () {
      if ((this.dmCases.data.length == 0 && this.selectedTab == 'DmCases') ||
        (this.dmAgreements.data.length == 0 && this.selectedTab == 'DmAgreements') ||
        (this.deposits.data.length == 0 && this.selectedTab == 'Deposits') ||
        (this.dmInvestigations.data.length == 0 && this.selectedTab == 'DmInvestigations') )
        return true;
      else
        return false;
    },
    agreementInstallments: function () {
      let temp = this.dmAgreements.data.filter(a => a.agreemNo == this.selectedAgreemNo);

      if (temp && temp.length > 0)
        return temp[0].installments;

      return [];
    },
  },
  watch: {
    selectedTab: function (val) {
      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    },   
  },
  methods: {
    init() {
      this.propertyId = this.$route.params.propertyId;
      this.custkey = this.$route.params.custkey;

      this.selectedTab = 'DmCases';
      this.isDmExpanded = true;

      this.fillColumns();
      this.getData();
    },
    fillColumns() {
      this.dmCases.cols.length == 0;
      this.dmAgreements.cols.length == 0;
      this.deposits.cols.length == 0;
      this.dmInvestigations.cols.length == 0;

      //==============================
      //Dm cases
      this.dmCases.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      this.dmCases.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      this.dmCases.cols.push({ dataField: 'caseId', caption: this.$t('enquiriesAccount.caseId') });
      this.dmCases.cols.push({ dataField: 'activeCase', caption: this.$t('enquiriesAccount.activeCase') });
      this.dmCases.cols.push({ dataField: 'activityStage', caption: this.$t('enquiriesAccount.activityStage') });
      this.dmCases.cols.push({ dataField: 'openDate', caption: this.$t('enquiriesAccount.openDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });

      //==============================
      //dm agreements
      this.dmAgreements.cols.push({ dataField: 'agreementTypeDisplay', caption: this.$t('activities.agreementType') });
      //this.dmAgreements.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      //this.dmAgreements.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      this.dmAgreements.cols.push({ dataField: 'reference', caption: this.$t('enquiriesAccount.reference') });
      this.dmAgreements.cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesAccount.effectiveDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.dmAgreements.cols.push({ dataField: 'agreemAmountS', caption: this.$t('enquiriesAccount.agreemAmountS') });
      this.dmAgreements.cols.push({ dataField: 'immediatePaymentS', caption: this.$t('enquiriesAccount.immediatePaymentS') });
      this.dmAgreements.cols.push({ dataField: 'installmentAmountS', caption: this.$t('enquiriesAccount.installmentAmountS') });
      this.dmAgreements.cols.push({ dataField: 'instNo', caption: this.$t('enquiriesAccount.instNo') });
      this.dmAgreements.cols.push({ dataField: 'lastInstalment', caption: this.$t('enquiriesAccount.lastInstalment'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.dmAgreements.cols.push({ dataField: 'restInstallments', caption: this.$t('enquiries.restInstallments') });
      this.dmAgreements.cols.push({ dataField: 'calculatedStatusS', caption: this.$t('enquiriesAccount.calculatedStatusS') });

      //==============================
      //dm investigations
      this.dmInvestigations.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      this.dmInvestigations.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      this.dmInvestigations.cols.push({ dataField: 'sourceS', caption: this.$t('enquiriesAccount.sourceS') });
      this.dmInvestigations.cols.push({ dataField: 'id', caption: this.$t('enquiriesAccount.id') });
      this.dmInvestigations.cols.push({ dataField: 'statusS', caption: this.$t('enquiriesAccount.status') });
      this.dmInvestigations.cols.push({ dataField: 'investigationDate', caption: this.$t('enquiriesAccount.investigationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.dmInvestigations.cols.push({ dataField: 'completionDate', caption: this.$t('enquiriesAccount.completionDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.dmInvestigations.cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesAccount.documentNo') });

      //==============================
      //dm deposits
      if (this.BillingMasterCustomer) {
        this.deposits.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
        this.deposits.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      } else {
        this.deposits.cols.push({ dataField: 'property', caption: this.$t('enquiriesAccount.property') });
      }

      this.deposits.cols.push({ dataField: 'amount', caption: this.$t('enquiriesAccount.amount') });
      this.deposits.cols.push({ dataField: 'refunded', caption: this.$t('enquiriesAccount.refunded') });
      this.deposits.cols.push({ dataField: 'balance', caption: this.$t('enquiriesAccount.balance') });
      this.deposits.cols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      this.deposits.cols.push({ dataField: 'bankName', caption: this.$t('enquiriesAccount.BankName') });
      this.deposits.cols.push({ dataField: 'bankAddress', caption: this.$t('enquiriesAccount.BankAddress') });
      this.deposits.cols.push({ dataField: 'bankEmail', caption: this.$t('enquiriesAccount.BankEmail') });
      this.deposits.cols.push({ dataField: 'receiptNo', caption: this.$t('receipting.receiptNo') });
      this.deposits.cols.push({ dataField: 'applFormNo', caption: this.$t('enquiriesAccount.CsAppsNo') });
      this.deposits.cols.push({ dataField: 'submitDate', caption: this.$t('enquiriesAccount.SubmittedOn'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.deposits.cols.push({ dataField: 'expiryDate', caption: this.$t('activities.expiryDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.deposits.cols.push({ dataField: 'comments', caption: this.$t('enquiriesCustomerDetails.comments') });
    },
    getData() {
      this.getDmCases(true);
      this.getDmAgreements(true);
      this.getDmInvestigations(true);
      this.getDeposits(true);

      this.getCustomerDisplayInfo();
    },

    getDmCases(loader = false) {
        this.dmCases.isLoading = loader;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.dmCases.pageingOption
      }

      axios.get('/Enquiries2/GetDmCases?account=' + this.custkey + '&page=' + this.dmCases.pageingOption.page + '&pageSize=' + this.dmCases.pageingOption.pageSize)
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.dmCases.data = response.data.items;

            this.dmCases.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.dmCases.isLoading = false);
    },
    getDmAgreements(loader = false) {
      if (loader)
        this.dmAgreements.isLoading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.dmAgreements.pageingOption
      }

      axios.post('/Enquiries/getCustomerDmAgreements', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.dmAgreements.data = response.data.items;

            this.dmAgreements.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.dmAgreements.isLoading = false);
    },
    getDmInvestigations(loader = false) {
      if (loader)
        this.dmInvestigations.isLoading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.dmInvestigations.pageingOption
      }

      axios.post('/Enquiries/getDmInvestigations', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.dmInvestigations.data = response.data.items;

            this.dmInvestigations.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.dmInvestigations.isLoading = false);
    },
    getDeposits(loader = false) {
      if (loader)
        this.deposits.isLoading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.deposits.pageingOption
      }

      axios.post('/Enquiries/getDeposits', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            if (response.data.data.status == 0) {
              if (response.data.items && response.data.items.length > 0) {
                response.data.items.forEach(i => {
                  i.amount = this.$options.filters.twoDecimals(i.amount);
                  i.refunded = this.$options.filters.twoDecimals(i.refunded);
                });
              }

              this.deposits.data = response.data.items;

              this.deposits.totalRow = response.data.itemsCount;
            }
            else {
              this.getDataFailed();
              this.$oldAlertMsg(response.data.data.text, 4);
            }
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.deposits.isLoading = false);
    },

    getAgreemInstallments(info) {
      if (info != undefined) {
        this.selectedAgreemNo = info.rows[info.newRowIndex].data.agreemNo;
      }
    },
  },
}
